/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type AiMessagingControlsController from 'uplisting-frontend/pods/ai-messaging/controls/controller';

interface ControlsContentSignature {
  Element: HTMLDivElement;
  Args: {
    ctrl: AiMessagingControlsController;
  };
}

const ControlsContent = templateOnlyComponent<ControlsContentSignature>();

export default ControlsContent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiMessaging::ControlsContent': typeof ControlsContent;
  }
}
